import ComputerSkillForm from './ComputerSkillForm';

export default ComputerSkillForm;
